import {
  Box,
  Button,
  Divider,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { Navigate, useNavigate } from "react-router-dom";
import { APP_ICONS } from "../../assets";
import AppContainer from "../../components/containers/AppContainer";
import CustomBar from "../../components/customBar";
import DynamicTable from "../../components/dynamicTable";
import Loader from "../../components/loader";
import SelectInput from "../../components/select";
import TextInput from "../../components/textInput";
import { getAllReturnOrders } from "../../services/Returns";
import { constants } from "../../theme/Variables";
import NavigationDrawer from "./../../components/navigationDrawer/index";

const selectInputWith = {
  width: { xs: "100%", sm: "150px" },
};

const tableHeader = [
  "ORDER #ID",
  "RETURN ORDER #ID",
  "VENDOR DETAILS",
  "USER DETAILS",
  "ACTION",
];

const displayRows = [
  "orderId",
  "returnOrderId",
  "vendor_details",
  "user_details",
  "actions",
];

const headersForCsv = [
  { label: "Returns #ID", key: "_id" },
  { label: "Returns NAME", key: "name" },
  { label: "EMAIL", key: "email" },
  { label: "PHONE", key: "phoneNumber" },
  { label: "JOINED ON", key: "createdAt" },
  { label: "STATUS", key: "status" },
];

const ReturnOrders = () => {
  const navigate = useNavigate();
  const [filterByStatus, setFilterByStatus] = useState("All");
  const [searchValue, setSearchValue] = useState("");
  const [allReturns, setAllReturns] = useState([]);
  const [filteredReturns, setFilteredReturns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    handleFetchAllReturns();
  }, []);

  useEffect(() => {
    filterAndSearchUsers();
  }, [filterByStatus, searchValue, allReturns]);

  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({
      snackType: type,
      snackMessage: message,
    });
  };

  const handleFetchAllReturns = async () => {
    try {
      setIsLoading(true);
      const response = await getAllReturnOrders();
      setIsLoading(false);
      if (response.status == 200 || response.status == 201) {
        let data = response?.data?.data;
        setAllReturns(data);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.data?.message);
      console.log(error, "errorerrorerrorerror");
      setIsLoading(false);
    }
  };

  const filterAndSearchUsers = () => {
    let filteredData = [...allReturns];

    if (filterByStatus !== "All") {
      filteredData = filteredData.filter(
        (vendor) => vendor.returnSt === filterByStatus
      );
    }

    if (searchValue.trim()) {
      filteredData = filteredData.filter(
        (vendor) =>
          vendor?.name?.toLowerCase().includes(searchValue.toLowerCase()) ||
          vendor.email?.toLowerCase().includes(searchValue.toLowerCase())
      );
    }
    setFilteredReturns(filteredData);
  };

  return (
    <NavigationDrawer>
      {/* Mini Header */}
      <CustomBar title={"RETURN-ORDERS"} />

      <AppContainer>
        <Stack
          px={3}
          py={2}
          gap={2}
          direction={{ md: "row" }}
          alignItems={"center"}
        >
          {/* <TextInput
            sx={{ flex: 1 }}
            placeholder={"Search Vendors"}
            InputStartIcon={<img src={APP_ICONS.searhIcon} width={20} />}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          /> */}
          <Stack
            direction={{ sm: "row" }}
            width={"100%"}
            flex={2}
            gap={2}
            justifyContent={{ md: "flex-end" }}
          >
            <SelectInput
              placeholder={"Sort by status"}
              formStyleProps={selectInputWith}
              value={filterByStatus}
              onChange={(e) => setFilterByStatus(e.target.value)}
            >
              <MenuItem value={"All"}>All</MenuItem>
              <MenuItem value={"Active"}>Active</MenuItem>
              <MenuItem value={"InActive"}>InActive</MenuItem>
            </SelectInput>
            <CSVLink
              data={filteredReturns}
              headers={headersForCsv}
              filename="filtered-users.csv"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <Box
                height={40}
                bgcolor={"#003B95"}
                borderRadius={2}
                sx={{ width: { xs: "100%", md: 120 } }}
              >
                <Button>
                  <Typography color="#FFF">Export</Typography>
                </Button>
              </Box>
            </CSVLink>
          </Stack>
        </Stack>
        <Divider />
        {filteredReturns?.length > 0 ? (
          <DynamicTable
            tableHeader={tableHeader}
            displayRows={displayRows}
            tableData={filteredReturns}
            showPagination={true}
            showEdit={true}
            handleEdit={(row) => {
              navigate("/Edit-Return-Order", { state: row });
            }}
            showEditAndDelete={true}
          />
        ) : (
          <Typography
            color="black"
            fontSize={14}
            fontWeight={700}
            textAlign={"center"}
            padding={"30px 0"}
          >
            No Returns Found!
          </Typography>
        )}
      </AppContainer>
      <Loader isloading={isLoading} />
    </NavigationDrawer>
  );
};

export default ReturnOrders;
